import { render, staticRenderFns } from "./MTMLUAYG.vue?vue&type=template&id=cef6cfe4&scoped=true"
import script from "./MTMLUAYG.vue?vue&type=script&lang=js"
export * from "./MTMLUAYG.vue?vue&type=script&lang=js"
import style0 from "./MTMLUAYG.vue?vue&type=style&index=0&id=cef6cfe4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef6cfe4",
  null
  
)

export default component.exports